import classname from 'classnames'
import PropTypes from 'prop-types'
import { ReactComponent as SelectedDataElementIcon } from '@/assets/svgs/selected-radio-icon.svg'
import InfoIcon from '@/components/EFormV2/InfoIcon'

const SelectorBox = ({ active, label, image, submit, radioLeft, infoTooltip }) => {

	const selectorClass = classname({
		'selector-box-2': true,
		'selector-box-2--active': active
	})

	const radio = (
		<>
			{!active && <div className="selector-box-2__circle"></div>}
			{active &&
			<div className='DS__icon--radio-icon'>
			<SelectedDataElementIcon />
			</div>}
		</>
	)

	return (
		<div className={selectorClass} onClick={submit ? submit : null}>
			<div className="selector-box__left">
				{radioLeft && radio}
				{image && (<div className="selector-box__avatar" style={{ backgroundImage: `url(${image})` }}></div>)}
				<div className="selector-box__label">{label}</div>
			</div>
			<div className="selector-box__right">
				{!radioLeft && radio}
				<InfoIcon content={infoTooltip} iconClassName="selector-box-2__info-icon" />
			</div>
		</div>
	)
}

SelectorBox.propTypes = {
	active: PropTypes.bool,
	label: PropTypes.string,
	image: PropTypes.string,
	submit: PropTypes.func,
	radioLeft: PropTypes.bool,
	infoTooltip: PropTypes.string,
}

export default SelectorBox
